interface RemoveLogoIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export function RemoveLogoIcon({ color = 'currentColor', ...svgProps }: RemoveLogoIconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <rect x="5" y="5" width="22" height="22" rx="2.2" stroke={color} />
      <g>
        <path d="M10.4833 18.26V12.875H9.125V18.26H10.4833Z" fill={color} />
        <path
          d="M12.7283 14.2969C11.5044 14.2969 10.7192 15.091 10.7192 16.339C10.7192 17.5869 11.5044 18.3811 12.7283 18.3811C13.9522 18.3811 14.7374 17.5869 14.7374 16.339C14.7374 15.091 13.9522 14.2969 12.7283 14.2969ZM12.7283 15.3784C13.0962 15.3784 13.3084 15.7339 13.3084 16.339C13.3084 16.944 13.0962 17.2995 12.7283 17.2995C12.3604 17.2995 12.1482 16.944 12.1482 16.339C12.1482 15.7339 12.3604 15.3784 12.7283 15.3784Z"
          fill={color}
        />
        <path
          d="M16.3325 14.3045C15.4128 14.3045 14.8398 15.0683 14.8398 16.2558C14.8398 17.4432 15.3987 18.2071 16.2971 18.2071C16.7004 18.2071 17.0682 18.0105 17.2804 17.6701H17.2946V18.0407C17.2946 18.6685 17.0753 18.8727 16.7286 18.8727C16.4598 18.8727 16.2971 18.7365 16.283 18.5021H14.9954C15.0803 19.2886 15.6887 19.75 16.7074 19.75C17.9171 19.75 18.6175 19.2206 18.6175 17.9953V14.4179H17.3512V14.9322H17.337C17.1177 14.5465 16.7428 14.3045 16.3325 14.3045ZM16.7923 15.4011C17.1248 15.4011 17.337 15.7415 17.337 16.2558C17.337 16.7701 17.1248 17.1029 16.7923 17.1029C16.4457 17.1029 16.2334 16.7701 16.2334 16.2558C16.2334 15.7415 16.4457 15.4011 16.7923 15.4011Z"
          fill={color}
        />
        <path
          d="M20.8659 14.2969C19.642 14.2969 18.8568 15.091 18.8568 16.339C18.8568 17.5869 19.642 18.3811 20.8659 18.3811C22.0898 18.3811 22.875 17.5869 22.875 16.339C22.875 15.091 22.0898 14.2969 20.8659 14.2969ZM20.8659 15.3784C21.2338 15.3784 21.446 15.7339 21.446 16.339C21.446 16.944 21.2338 17.2995 20.8659 17.2995C20.498 17.2995 20.2858 16.944 20.2858 16.339C20.2858 15.7339 20.498 15.3784 20.8659 15.3784Z"
          fill={color}
        />
      </g>
      <line x1="8" y1="24.2929" x2="24.2929" y2="8" stroke={color} strokeLinecap="round" />
    </svg>
  );
}

